import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { SvgModel, geo2svg } from './geo2svg';

@Directive({
  selector: '[lGeoSvg]'
})
export class GeoSvgDirective implements OnInit {

  @Input('lGeoSvg')
  public geoJson: any;

  @Input()
  public isStringConvertGeoJson: boolean = false;

  @Input()
  public svgModel: SvgModel = new SvgModel();

  constructor(private _ele: ElementRef) { }

  ngOnInit(): void {
    if (this.geoJson) {
      if (this.isStringConvertGeoJson) {
        this._ele.nativeElement.innerHTML = geo2svg(JSON.parse(this.geoJson), this.svgModel);
      } else {
        this._ele.nativeElement.innerHTML = geo2svg(this.geoJson, this.svgModel);
      }
    }
  }

}
